import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appWindowHeightDirective]',
    standalone: false
})
export class WindowHeightDirective {
  constructor(public element: ElementRef) {}
  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event.target'])
  @HostListener('window:resize', ['$event.target'])
  public onResize = (targetElement) => {
    /*  //console.log('WindowHeightDirective');
  //console.log(window.innerWidth);
  //console.log(window.innerHeight);*/
    this.element.nativeElement.style.height = window.innerHeight + 'px';
  };
}
